import {
  FETCH_CONDITIONS,
  FETCH_CONDITIONS_SUCCESS,
  FETCH_CONDITIONS_FAILURE,
  CREATE_CONDITION,
  UPDATE_CONDITION,
  DELETE_CONDITION
} from "../constants/hwk";
import { SUCCESS_MESSAGE, ERROR_MESSAGE } from "../../store/constants/general";

import { put, call, takeLatest } from "redux-saga/effects";
import { API } from "../../api";

function* fetchConditions(action) {
  try {
    const response = yield call(API.getConditions);
    yield put({ type: FETCH_CONDITIONS_SUCCESS, data: response.data });
  } catch (e) {
    console.log("ERROR in fetchConditions", e.message);
    yield put({ type: FETCH_CONDITIONS_FAILURE, error: e.message });
    yield put({ type: ERROR_MESSAGE, message: e.message });
  }
}

function* createCondition(action) {
  try {
    const response = yield call(API.createCondition, action.payload);

    yield put({
      type: SUCCESS_MESSAGE,
      message: "Successfully created Condition",
      payload: response
    });
    yield put({ type: FETCH_CONDITIONS });
  } catch (e) {
    console.log("SAGA ERROR", e.message);
    yield put({ type: ERROR_MESSAGE, message: e.message });
  }
}

function* updateCondition(action) {
  try {
    const response = yield call(API.updateCondition, action.payload);

    yield put({
      type: SUCCESS_MESSAGE,
      message: "Successfully updated Condition",
      payload: response
    });
    yield put({ type: FETCH_CONDITIONS });
  } catch (e) {
    console.log("SAGA ERROR", e.message);
    yield put({ type: ERROR_MESSAGE, message: e.message });
  }
}


function* deleteCondition(action) {
  try {
    const response = yield call(API.deleteCondition, action.id);

    yield put({
      type: SUCCESS_MESSAGE,
      message: "Successfully deleted Condition",
      payload: response
    });
    yield put({ type: FETCH_CONDITIONS });
  } catch (e) {
    console.log("SAGA ERROR", e.message);
    yield put({ type: ERROR_MESSAGE, message: e.message });
  }
}

export default function* rootSaga() {
  yield takeLatest(FETCH_CONDITIONS, fetchConditions);
  yield takeLatest(CREATE_CONDITION, createCondition);
  yield takeLatest(UPDATE_CONDITION, updateCondition);
  yield takeLatest(DELETE_CONDITION, deleteCondition);
}
